// Level-up card copy (10 §5.4 P0 catalogue mirrored from crates/fk-world heroes.rs LEVEL_CARDS).
// 11 §10.4: no percentages in level-up copy — enforced by levelup.test.ts.
export const LEVEL_CARDS: Record<number, { title: string; text: string }> = {
  1: { title: 'Hardy', text: 'Max HP +3' },
  2: { title: 'Bulwark', text: 'Guard +1 (one less damage from every hit)' },
  3: { title: 'Keen edge', text: 'Weapon damage +1' },
  4: { title: 'Attuned', text: 'Spell damage +1 and heals +1' },
  5: { title: 'Fleet', text: 'Move +1 tile' },
};

export const OUTCOMES = ['Victory', 'Wipe', 'Fled', 'Surrendered', 'Stalemate', 'Abandoned', 'Failed'];
